<div class="footer" [ngStyle]="{'background-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.FooterBackgroundColor}">
  <div class="footer__text-logo" tabindex="0">
    <span class="default-form-field" [ngStyle]="{color:ls.restaurantWidgetSettings$.value.WidgetCustomization.FooterTextColor}">{{'copyRight' | translate}}</span>
    <img class="footer__logo" src="assets/images/Agilysys.png" alt="agilysys-logo">
  </div>
</div>
